/* eslint-disable react/prefer-stateless-function */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SubsContext } from '../Billsby/SubscriptionInfo';
// import Root from '../../Root';

const Modal = styled.div`
  position: fixed;
  top: 300;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  text
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
`;

export const isAllowed = (level, subscriptionLevel) => {
  if (subscriptionLevel) {
    if (level === "ICON Pro") {
      return subscriptionLevel === "ICON Pro";
    } else if (level === "ICON Plus") {
      return subscriptionLevel === "ICON Plus" ||
        subscriptionLevel === "ICON Pro";
    } else if (level === "ICON Core") {
      return subscriptionLevel === "ICON Core" ||
        subscriptionLevel === "ICON Plus" ||
        subscriptionLevel === "ICON Pro";
    } else if (level === "Undefined") {
      return subscriptionLevel === 'ICON Pro';
    }
  }
  return true;
}

const Subscription = ({ service, level, children }) => {
  const { subscriptionLevel } = useContext(SubsContext);
  const allowed = isAllowed(level, subscriptionLevel);

  return (
    <span>
      {!allowed && (
        <Modal>
          <div>
            <h1 style={{ color: "red" }}><center><b>{service}</b></center></h1>
            <h2 style={{ color: "red" }}><center>You need a Subscription Level of {level !== "ICON Pro" ? "at least " : ""}<b>{level}</b> to access this service</center></h2>
          </div>
        </Modal>
      )}
      <span>{children}</span>
    </span>
  );
}

Subscription.propTypes = {
  service: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
}

export default Subscription;




// WEBPACK FOOTER //
// ./src/components/Subscription/Subscription.jsx